import { Theme } from '@mui/material';
import Lines from '../../assets/images/lines.png';
import LoginBg from '../../assets/images/login-bg.png';

import { getBrandTokens } from '../../theme/getBrandTokens';
import { tokenVar } from '../../theme/brandCssVar';

export const Styles = (theme: Theme) => {
  const tokens = getBrandTokens(theme);

  return {
    container: {
      backgroundColor: theme.palette.background.black,
      width: theme.custom.width['100vw'],
      display: 'flex',
    },
    dummy: {
      backgroundImage: `url(${LoginBg}), url(${Lines})`,
      backgroundRepeat: 'no-repeat',
      position: 'absolute',
      top: '0',
      left: '0',
      width: theme.custom.width['100%'],
      height: theme.custom.height['70%'],
      backgroundSize: 'cover',
    },
    leftContainer: {
      width: theme.custom.width['59%'],
    },

    rightContainer: {
      width: theme.custom.width['37%'],
      backgroundColor: theme.palette.background.black_1100,
      height: theme.custom.height['90%'],
      margin: theme.custom.margin.largeXX,
      marginLeft: theme.custom.margin.mediumXX,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      padding: theme.custom.padding['3_5'],
      gap: theme.custom.gap['10%'],
      borderRadius: theme.custom.borderRadius['2'],
      '@media (max-width: 1300px)': {
        padding: theme.custom.padding['2_5'],
      },
      '@media (max-width: 992px)': {
        margin: theme.custom.margin.largeXXX,
      },
      '@media (max-width: 576px)': {
        padding: '0',
        backgroundColor: 'transparent',
        gap: theme.custom.gap['5%'],
        zIndex: 10,
        margin: `${theme.custom.margin.largeX} ${theme.custom.margin.mediumXX}`,
      },
    },
    imgContainer: {
      height: theme.custom.height['3'],
      maxWidth: theme.custom.width['50%'],
      '@media (max-width: 576px)': {
        height: theme.custom.height['2'],
        maxWidth: theme.custom.width['60%'],
      },
    },
    img: {
      width: 'auto',
      maxWidth: '100%',
      height: theme.custom.height['100%'],
      objectFit: 'contain' as const,
      objectPosition: 'left center' as const,
      display: 'block' as const,
    },
    loginFormContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.custom.gap['4_5'],
      width: theme.custom.width['100%'],
      overFlowStyle: 'none',
      scrollbarWidth: 'none',
      '&::WebkitScrollbar': {
        display: 'none' /* Safari and Chrome */,
      },
      '@media (max-width: 576px)': {
        gap: theme.custom.gap['2_5'],
      },
      '@media (max-width: 420px)': {
        gap: theme.custom.gap.large,
      },
    },
    back: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.custom.gap.small,
      fontWeight: theme.typography.fontWeight.medium,
      fontSize: theme.typography.textSize.medium,
      lineHeight: theme.typography.lineHeight.small,
      color: theme.palette.text.septenary,
      top: '-2.5rem',
      cursor: 'pointer',
    },
    formHeading: {
      fontWeight: theme.typography.fontWeight.medium,
      fontSize: theme.typography.textSize.large,
      lineHeight: theme.typography.lineHeight['2_625'],
      color: theme.palette.primary.main,
      marginBottom: theme.custom.margin.medium,
    },
    formDesc: {
      fontWeight: theme.typography.fontWeight.small,
      fontSize: theme.typography.textSize.medium,
      lineHeight: theme.typography.lineHeight.small,
      color: theme.palette.text.septenary,
    },
    emoji: {
      top: '-0.313rem',
      marginLeft: theme.custom.margin.xSmall,
    },
    emptyContainer: {
      flex: 1,
      '@media (max-width: 420px)': {
        flex: 2,
      },
    },
    changePhoneNo: {
      fontSize: theme.typography.textSize['0_875'],
      fontWeight: theme.typography.fontWeight.medium,
      color: tokenVar(tokens, 'linkColor'),
      cursor: 'pointer',
    },
    formContainer: {
      marginBottom: theme.custom.margin['4_5'],
      '@media (max-width: 576px)': {
        marginBottom: theme.custom.margin.largeX,
      },
      '@media (max-width: 420px)': {
        marginBottom: theme.custom.margin.mediumXX,
      },
    },
    phoneNo: {
      fontWeight: theme.typography.fontWeight.normal,
      fontSize: theme.typography.textSize.medium,
      lineHeight: theme.typography.lineHeight.small,
      color: theme.palette.primary.main,
    },
    fullWidthContainer: {
      width: theme.custom.width['100%'],
    },
    otpContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.custom.gap.medium,
    },
    resendCode: {
      fontWeight: theme.typography.fontWeight.medium,
      fontSize: theme.typography.textSize['0_875'],
      color: theme.palette.text.nonary,
    },
    otpTimer: {
      fontWeight: theme.typography.fontWeight.normal,
      color: theme.palette.text.elevenary,
    },
    submitBtn: {
      width: theme.custom.width['100%'],
      height: theme.custom.width['3_5'],
    },
  };
};
